<template>
    <!-- https://www.svgrepo.com/svg/374907/hide-mobile?edit=true -->
    <svg
        fill="#F09A0FFF"
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        height="20px"
        viewBox="0 0 52 52"
        enable-background="new 0 0 52 52"
        xml:space="preserve"
    >
        <g id="SVGRepo_bgCarrier" stroke-width="0" />

        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

        <g id="SVGRepo_iconCarrier">
            <g>
                <path
                    d="M36.1,25.3v14.1c0,0.7-0.6,1.4-1.4,1.4H20.6L12,49.4c0.6,0.4,1.3,0.6,2,0.6h24c2,0,3.7-1.7,3.7-3.7V19.7 L36.1,25.3z M26,48.1c-1.6,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8s2.8,1.2,2.8,2.8S27.6,48.1,26,48.1z"
                />
                <path
                    d="M10.3,45.6l5.7-5.7c0,0,0,0,0-0.1l20.2-20.2v0.1l5.5-5.5v-0.1l7-7c0.7-0.6,0.8-1.7,0.3-2.2L47,3 c-0.6-0.6-1.6-0.5-2.2,0.3l-3.1,3.1V5.7C41.7,3.7,40,2,38,2H14c-2,0-3.7,1.7-3.7,3.7v32.1l-7.1,7.1C2.6,45.5,2.5,46.5,3,47L4.9,49 c0.6,0.6,1.6,0.5,2.2-0.3L10.3,45.6L10.3,45.6z M15.8,10.8c0-0.7,0.6-1.4,1.4-1.4h17.5c0.7,0,1.4,0.6,1.4,1.4v1.2L15.8,32.2V10.8z"
                />
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "HideMobile",
};
</script>

<style scoped></style>
